<template>
  <div>
    <app-header :navlinks="navigationLinks" />
    <b-container class="breadcrumb-container">
      <b-row>
        <b-col>
          <app-nav-breadcrumb :breadcrumb-items="breadcrumbItems" />
        </b-col>
      </b-row>
    </b-container>
    <main>
      <div id="heading-section">
        <heading-section />
      </div>
      <div id="recursos-informativos">
        <informational-resources-section />
      </div>
      <div id="indicadores" class="mb-5 mb-lg-0">
        <indicadores-section />
      </div>
      <contact-info-bar variant="green" />
    </main>
  </div>
</template>

<script>
import Header from '@/components/Header/Header.vue';
import Breadcrumb from '@/components/Breadcrumb/Breadcrumb.vue';
import HeadingSection from '@/components/CancerColoUtero/HeadingSection/HeadingSection.vue';
import InformationalResourcesSection from '@/components/CancerColoUtero/InformationalResourcesSection/InformationalResourcesSection.vue';
import IndicadoresSection from '@/components/CancerColoUtero/IndicadoresSection/IndicadoresSection.vue';
import ContactInfoBar from '@/components/ContactInfoBar/ContactInfoBar.vue';

export default {
  name: 'cancer-colo-utero-view',
  metaInfo: {
    title: 'Câncer de colo do útero | Observatório do Câncer RS',
  },
  components: {
    'app-header': Header,
    'app-nav-breadcrumb': Breadcrumb,
    'heading-section': HeadingSection,
    'informational-resources-section': InformationalResourcesSection,
    'indicadores-section': IndicadoresSection,
    'contact-info-bar': ContactInfoBar,
  },
  data: () => ({
    navigationLinks: [
      { label: '', link: '#heading-section', isPlaceholder: true },
      { label: 'Recursos informativos', link: '#recursos-informativos' },
      { label: 'Indicadores', link: '#indicadores' },
    ],
    breadcrumbItems: [
      {
        text: 'Observatório do Câncer RS',
        to: { name: 'home' },
      },
      {
        text: 'Câncer de colo do útero',
        active: true,
      },
    ],
  }),
};
</script>

<style lang="scss" scoped>
.breadcrumb-container {
  padding-top: 1.5rem;
  margin-bottom: 3rem;
}

@include media-breakpoint-up(lg) {
  .breadcrumb-container {
    padding-top: 5.5rem;
    margin-bottom: 0;
  }
}
</style>
